<template>
    <div class="background rounded-lg">
        <Block v-if="loading" />
        <div>
            <div class="row">
                <div class="col-12 p-2">
                    <VersatileFilter
                        class="pt-3"
                        advancedFilter
                        :search="search"
                        hideSearchField
                        disableDates
                        hideLimitLabel
                        @emptyFilter="clearFilter"
                        :key="Reloadfilter"
                        :columnfilterEndpoint="getData"
                        :columnsSearch.sync="columsConfig"
                    >
                        <div class="d-flex flex-wrap align-center justify-space-between px-4 pb-2">
                            <div class="d-flex flex-wrap align-center">
                                <button
                                    v-for="badge in statusBadges"
                                    :key="badge.value"
                                    type="button"
                                    class="estado-badge estado-badge-button mr-2 mb-2"
                                    :class="[badge.className, { 'estado-badge--active': selectedStatus === badge.value }]"
                                    @click="toggleStatusFilter(badge.value)"
                                >
                                    {{ badge.label }} ({{ badge.count }})
                                </button>
                            </div>
                            <div class="d-flex flex-wrap align-center">
                                <v-btn class="btn-save mb-2 mr-2" :loading="loading" :disabled="loading || !filteredReportsData.length" @click="onExportExcelClick">
                                    Exportar Excel
                                </v-btn>
                                <v-btn class="btn-save mb-2" :loading="loading" :disabled="loading || !filteredReportsData.length" @click="onExportPdfClick">
                                    Exportar PDF
                                </v-btn>
                            </div>
                        </div>
                        <DxDataGrid
                            ref="gridRef"
                            :data-source="filteredReportsData"
                            :show-borders="true"
                            :column-auto-width="true"
                            @exporting="onExporting"
                            style="max-height: 600px;"
                            :paging="{ enabled: false }"
                            :columns="columns"
                            :sorting="{ mode: 'none' }"
                        >
                            <template #expirationDateTemplate="{ data }">
                                <span>{{ formatDisplayDate(data.value) }}</span>
                            </template>
                            <template #estadoTemplate="{ data }">
                                <span :class="getEstadoClass(data.value)" class="estado-badge">
                                    {{ data.value }}
                                </span>
                            </template>
                            <DxScrolling row-rendering-mode="virtual" showScrollbar="always" useNative="false" />
                            <DxExport :enabled="true" :formats="['xlsx']" />
                            <DxColumnChooser
                                :enabled="true"
                                mode="select"
                                title="Columnas visibles"
                                :height="400"
                                :width="400"
                            />
                        </DxDataGrid>
                    </VersatileFilter>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Block from '@/components/Block.vue';
import VersatileFilter from '@/components/VersatileFilter';
import {
    DxDataGrid,
    DxExport,
    DxScrolling,
    DxColumnChooser,
} from 'devextreme-vue/data-grid';
import { printToExcel } from "@/helpers/printToexcel";
import moment from "moment";

export default {
    name: "ProductExpirationAlerts",
    components: {
        VersatileFilter,
        DxDataGrid,
        DxExport,
        DxScrolling,
        Block,
        DxColumnChooser,
    },
    props: ['win', 'datafilter'],
    data() {
        return {
            loading: false,
            search: {},
            Reloadfilter: 0,
            selectedStatus: '',
            reportsData: [],
            columsConfig: [
                {
                    name: "calculationDate",
                    title: "Fecha de cálculo",
                    value: moment().format('DD/MM/YYYY'),
                    type: "date",
                },
                {
                    name: "daysToExpire",
                    title: "Días para próximo a vencer",
                    value: "30",
                    type: "number",
                },
                {
                    name: "ID_Item",
                    title: "Código",
                    value: "",
                    type: "text",
                },
                {
                    name: "ItemComercialName",
                    title: "Nombre del producto",
                    value: "",
                    type: "text",
                },
                {
                    name: "Warehouse",
                    title: "Almacén",
                    value: "",
                    type: "select",
                    options: [],
                },
                {
                    name: "ID_ItemBatch",
                    title: "Lote",
                    value: "",
                    type: "text",
                },
            ],
            columns: [
                { 
                    dataField: "ID_Item", 
                    caption: "Código", 
                    visible: true 
                },
                { 
                    dataField: "BarCode", 
                    caption: "Código Alterno", 
                    visible: true 
                },
                { 
                    dataField: "ItemComercialName", 
                    caption: "Nombre del producto", 
                    visible: true 
                },
                {
                    dataField: "ExpirationDate",
                    caption: "Fecha de vencimiento",
                    visible: true,
                    cellTemplate: "expirationDateTemplate",
                },
                {
                    dataField: "ID_ItemBatch",
                    caption: "Lote",
                    visible: true,
                },
                {
                    dataField: "ItemCurrentQuantity",
                    caption: "Existencias",
                    visible: true,
                    dataType: "number",
                    format: { type: "fixedPoint", precision: 2 },
                },
                { 
                    dataField: "WarehouseName", 
                    caption: "Almacén", 
                    visible: true 
                },
                {
                    dataField: "DiasParaVencer",
                    caption: "Días para vencer",
                    visible: true,
                    dataType: "number",
                },
                 {
                    dataField: "EstadoVencimiento",
                    caption: "Estado",
                    visible: true,
                    cellTemplate: "estadoTemplate",
                },
            ],
        };
    },
    computed: {
        statusBadges() {
            return [
                {
                    value: '',
                    label: 'Todos',
                    className: 'estado-badge--neutral',
                    count: this.reportsData.length,
                },
                {
                    value: 'Vencido',
                    label: 'Vencido',
                    className: 'estado-badge--danger',
                    count: this.getStatusCount('Vencido'),
                },
                {
                    value: 'Próximo a vencer',
                    label: 'Próximo a vencer',
                    className: 'estado-badge--warning',
                    count: this.getStatusCount('Próximo a vencer'),
                },
                {
                    value: 'En tiempo',
                    label: 'En tiempo',
                    className: 'estado-badge--success',
                    count: this.getStatusCount('En tiempo'),
                },
            ];
        },
        filteredReportsData() {
            if (!this.selectedStatus) {
                return this.reportsData;
            }

            return this.reportsData.filter(item => item.EstadoVencimiento === this.selectedStatus);
        },
    },
    mounted() {
        this.setWarehouseOptions();
    },
    methods: {
        getFilterValue(name, fallback = '') {
            const filter = this.columsConfig.find(item => item.name === name);
            return filter?.value ?? fallback;
        },
        getStatusCount(status) {
            return this.reportsData.filter(item => item.EstadoVencimiento === status).length;
        },
        setWarehouseOptions() {
            const warehouses = Array.isArray(this.datafilter?.Warehouses) ? this.datafilter.Warehouses : [];
            const sortedWarehouses = [...warehouses]
                .map(warehouse => ({
                    name: warehouse.name,
                    value: String(warehouse.value),
                }))
                .sort((left, right) => (left.name || '').localeCompare(right.name || ''));

            this.columsConfig[4].options = [
                { name: 'Todos', value: '' },
                ...sortedWarehouses,
            ];
        },
        getData(e) {
            this.loading = true;
            const params = {
                daysToExpire: String(this.getFilterValue('daysToExpire', '30') || '30'),
                calculationDate: String(this.getFilterValue('calculationDate', '') || ''),
                ID_Item: String(this.getFilterValue('ID_Item', '') || ''),
                ItemComercialName: String(this.getFilterValue('ItemComercialName', '') || ''),
                Warehouse: String(this.getFilterValue('Warehouse', '') || ''),
                ID_ItemBatch: String(this.getFilterValue('ID_ItemBatch', '') || ''),
            };

            if (e?.filter) {
                params.filter = e.filter;
            }

            return this.$API.inventoryReports.getInventoryExpirationAlerts(params).then(response => {
                this.reportsData = (response.data || []).map(item => ({
                    ...item,
                    ItemCurrentQuantity: Number(item.ItemCurrentQuantity || 0),
                    DiasParaVencer: Number(item.DiasParaVencer || 0),
                }));
            }).catch(error => {
                console.log(error);
                this.reportsData = [];
            }).finally(() => {
                this.loading = false;
            });
        },
        clearFilter() {
            const calculationDateFilter = this.columsConfig.find(item => item.name === 'calculationDate');
            const daysToExpireFilter = this.columsConfig.find(item => item.name === 'daysToExpire');
            const idItemFilter = this.columsConfig.find(item => item.name === 'ID_Item');
            const itemNameFilter = this.columsConfig.find(item => item.name === 'ItemComercialName');
            const warehouseFilter = this.columsConfig.find(item => item.name === 'Warehouse');
            const itemBatchFilter = this.columsConfig.find(item => item.name === 'ID_ItemBatch');

            if (calculationDateFilter) calculationDateFilter.value = moment().format('DD/MM/YYYY');
            if (daysToExpireFilter) daysToExpireFilter.value = "30";
            if (idItemFilter) idItemFilter.value = "";
            if (itemNameFilter) itemNameFilter.value = "";
            if (warehouseFilter) warehouseFilter.value = "";
            if (itemBatchFilter) itemBatchFilter.value = "";
            this.reportsData = [];
            this.selectedStatus = '';
        },
        formatDisplayDate(value) {
            if (!value) {
                return '';
            }

            const parsedDate = moment(value, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true);
            return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : value;
        },
        formatFileDate(value) {
            if (!value) {
                return 'sin-fecha';
            }

            const parsedDate = moment(value, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
            return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : 'sin-fecha';
        },
        getExcelFileName() {
            const daysToExpire = this.getFilterValue('daysToExpire', '30') || '30';
            const calculationDate = this.formatFileDate(this.getFilterValue('calculationDate', ''));

            return `Alertas vencimiento ${daysToExpire}d ${calculationDate}`;
        },
        formatPdfQuantity(value) {
            const number = Number(value || 0);
            return number.toLocaleString('es-SV', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        getCompanyName() {
            const branch = JSON.parse(localStorage.getItem('branch') || '{}');
            const user = JSON.parse(localStorage.getItem('user') || '{}');

            return branch.BusinessBillingName || branch.BusinessName || user.business || 'Empresa';
        },
        async waitForLoadingOverlay() {
            await this.$nextTick();
            await new Promise(resolve => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(resolve);
                });
            });
        },
        async exportPdfReport() {
            const { jsPDF } = await import('jspdf');
            const autoTable = (await import('jspdf-autotable')).default;
            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'letter',
                compress: true,
            });

            const companyName = this.getCompanyName();
            const reportTitle = 'Reporte de alertas de vencimiento';
            const generatedAt = moment().format('DD/MM/YYYY HH:mm:ss');
            const rows = this.filteredReportsData.map(item => ([
                item.ID_Item || '',
                item.ItemComercialName || '',
                this.formatDisplayDate(item.ExpirationDate),
                item.ID_ItemBatch || '',
                this.formatPdfQuantity(item.ItemCurrentQuantity),
                item.WarehouseName || '',
                String(item.DiasParaVencer ?? ''),
                item.EstadoVencimiento || '',
            ]));

            const pageWidth = doc.internal.pageSize.getWidth();
            doc.setTextColor(15, 23, 42);
            doc.setFont(undefined, 'bold');
            doc.setFontSize(12);
            doc.text(companyName.toUpperCase(), pageWidth / 2, 12, { align: 'center' });
            doc.setFontSize(11);
            doc.text(reportTitle.toUpperCase(), pageWidth / 2, 18, { align: 'center' });
            doc.setFont(undefined, 'normal');
            doc.setFontSize(8);
            doc.text(`Fecha de cálculo: ${this.formatDisplayDate(this.getFilterValue('calculationDate', '')) || 'N/D'}`, 14, 25);

            const currentY = 29;

            autoTable(doc, {
                startY: currentY + 2,
                margin: { left: 10, right: 10, top: 12, bottom: 15 },
                head: [[
                    'Código',
                    'Nombre del producto',
                    'Fecha de vencimiento',
                    'Lote',
                    'Existencias',
                    'Almacén',
                    'Días para vencer',
                    'Estado',
                ]],
                body: rows,
                theme: 'grid',
                styles: {
                    fontSize: 7,
                    cellPadding: 1.6,
                    textColor: [15, 23, 42],
                    valign: 'middle',
                    lineColor: [255, 255, 255],
                    lineWidth: 0,
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold',
                    halign: 'center',
                    lineColor: [0, 0, 0],
                    lineWidth: 0.264,
                },
                columnStyles: {
                    0: { cellWidth: 30 },
                    1: { cellWidth: 70 },
                    2: { cellWidth: 28, halign: 'center' },
                    3: { cellWidth: 24, halign: 'center' },
                    4: { cellWidth: 24, halign: 'right' },
                    5: { cellWidth: 40 },
                    6: { cellWidth: 24, halign: 'center' },
                    7: { cellWidth: 25, halign: 'center' },
                },
                didDrawPage: () => {
                    const pageHeight = doc.internal.pageSize.getHeight();
                    doc.setFontSize(7.5);
                    doc.setTextColor(71, 85, 105);
                    doc.text(
                        `${companyName} | ${generatedAt} | Página ${doc.internal.getNumberOfPages()}`,
                        pageWidth / 2,
                        pageHeight - 6,
                        { align: 'center' }
                    );
                },
            });

            doc.save(`${companyName} - Alertas de vencimiento (${this.formatFileDate(this.getFilterValue('calculationDate', ''))}).pdf`);
        },
        getEstadoClass(estado) {
            if (estado === 'Vencido') {
                return 'estado-badge--danger';
            }

            if (estado === 'Próximo a vencer') {
                return 'estado-badge--warning';
            }

            if (estado === 'En tiempo') {
                return 'estado-badge--success';
            }

            return '';
        },
        toggleStatusFilter(status) {
            this.selectedStatus = this.selectedStatus === status ? '' : status;
        },
        async onExportPdfClick() {
            this.loading = true;

            try {
                await this.waitForLoadingOverlay();
                await this.exportPdfReport();
            } catch (error) {
                console.error('Error durante la exportación a PDF:', error);
            } finally {
                this.loading = false;
            }
        },
        onExportExcelClick() {
            const grid = this.$refs.gridRef?.instance;
            if (!grid) {
                return;
            }

            printToExcel(
                { component: grid },
                this.getExcelFileName(),
                null,
                'Alertas de vencimiento'
            );
        },
        onExporting(e) {
            printToExcel(e, this.getExcelFileName(), null, 'Alertas de vencimiento');
        },
    }
}
</script>

<style scoped>
.background {
    background: white !important;
    color: white;
}

.btn-add {
    background-color: #3498db !important;
    color: white;
}

.btnsave {
    background-color: #3498db !important;
    color: white;
}

.estado-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: bold;
    border: 1px solid transparent;
    white-space: nowrap;
}

.estado-badge-button {
    border: 0;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.estado-badge-button:hover {
    transform: translateY(-1px);
}

.estado-badge--active {
    box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.12);
    opacity: 1;
}

.estado-badge--neutral {
    background-color: #e1f5fe;
    border-color: #03A9F4;
    color: #0277bd;
}

.estado-badge--danger {
    background-color: #ffebee;
    border-color: #F44336;
    color: #c62828;
}

.estado-badge--warning {
    background-color: #fff8e1;
    border-color: #FFC107;
    color: #b26a00;
}

.estado-badge--success {
    background-color: #e8f5e9;
    border-color: #81C784;
    color: #2e7d32;
}
</style>
